import React, { useCallback, useEffect, useState } from "react";
import { getAboutWork } from "../../api/about";
import Container from "../../components/Container";
import MainCard from "../../components/MainCard";
import PageContainer from "../../components/PageContainer";
import { toImagePath } from "../../utils/globalFunctions";

const Duties = () => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getAboutWork()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div>
      <PageContainer title="เกี่ยวกับสำนักงาน" bgImg="/images/hero-image.jpeg">
        <section>
          <Container isAlignTop>
            <MainCard>
              <img
                className="img-aspect-video"
                src={toImagePath(pageData?.topimage?.path)}
                alt=""
              />
              <div className="header-content">
                <h2 className="header-content__title">{pageData?.title}</h2>
              </div>
              <div className="md:px-12">
                <div className="text-md text-[#3D3D3D] font-medium py-6 px-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageData?.content,
                    }}
                  />
                </div>
              </div>
            </MainCard>
          </Container>
        </section>
      </PageContainer>
    </div>
  );
};

export default Duties;
